<template>
  <i-panel
    :visible="show"
    side="left"
    class="document-switcher-panel"
    @hide-panel="$emit('hide-panel')"
  >
    <template slot="header">
      <breadcrumbs
        class="document-switcher-breadcrumbs"
        data-testid="document-switcher-breadcrumbs"
        :items="breadcrumbs"
        size="lg"
      />
    </template>

    <div class="docs-list">
      <document-item
        v-for="docItem in documentList"
        :key="docItem.id"
        :document="docItem"
        data-testid="document-switcher-item"
        size="small"
        :options="{
          actionMenu: false,
          checks: false,
          currentDocLabel: true,
          tags: false,
          size: 'small',
          trustScoreInfo: false,
          defaultNumSignalsVisible: 2,
        }"
        @open-document="$emit('hide-panel')"
      />
    </div>
    <template slot="footer">
      <i-button
        text="View Customer"
        size="lg"
        type="neutral"
        class="view-customer-button"
        subtype="subtle"
        @button-click="viewCustomer"
      ></i-button>
    </template>
  </i-panel>
</template>
<script>
import { iButton, iPanel } from '@inscribe/signal';
import Breadcrumbs from '@/shared/components/Breadcrumbs.vue';
import DocumentItem from '@/V2/documents/document-list/DocumentItem';
import { mapGetters } from 'vuex';

export default {
  components: {
    Breadcrumbs,
    'document-item': DocumentItem,
    'i-button': iButton,
    'i-panel': iPanel,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      breadcrumbs: [
        {
          icon: 'medium-home',
          to: {
            name: 'customers-view',
          },
        },
        {
          text: this.$store.state.customers.selectedCustomer.name,
          to: {
            name: 'customer-overview',
            params: {
              customer_id: this.$route.params.customer_id,
            },
          },
        },
        {
          text: 'Documents',
          active: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getDocumentById: 'getDocumentById',
      getRemainingDocs: 'getRemainingDocs',
    }),
    documentList() {
      const currentDoc = this.getDocumentById(this.document.id);
      const remainingDocs = this.getRemainingDocs(this.document.id);
      let retArr = [];
      if (currentDoc) {
        retArr.push(currentDoc);
      }
      if (remainingDocs.length) {
        retArr = [...retArr, ...remainingDocs];
      }
      return retArr;
    },
  },
  watch: {
    $route() {
      this.$emit('hide-panel');
    },
  },
  methods: {
    viewCustomer() {
      this.$router.push({
        name: 'customer-overview',
        params: {
          customer_id: this.$route.params.customer_id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.document-switcher-panel {
  .docs-list {
    border: 1px solid $light-neutral-60;
    border-radius: 16px;
  }
  .document-switcher-breadcrumbs {
    max-width: 420px;
    min-height: 44px;
  }
  .view-customer-button {
    width: 100%;
  }
}
</style>
